import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../client';
import { queryKeys } from '../query-keys';
import type { AuditLogQueryParams, PaginatedAuditLogs, AuditLogEntry } from '../types';

/**
 * Fetch paginated audit logs with optional filters.
 */
export function useAuditLogs(params?: AuditLogQueryParams) {
  return useQuery({
    queryKey: queryKeys.admin.auditLogs(params),
    queryFn: async () => {
      const searchParams = new URLSearchParams();

      if (params?.adminId) searchParams.set('adminId', params.adminId);
      if (params?.action) searchParams.set('action', params.action);
      if (params?.targetType) searchParams.set('targetType', params.targetType);
      if (params?.targetId) searchParams.set('targetId', params.targetId);
      if (params?.fromDate) searchParams.set('fromDate', params.fromDate);
      if (params?.toDate) searchParams.set('toDate', params.toDate);
      if (params?.search) searchParams.set('search', params.search);
      if (params?.page) searchParams.set('page', String(params.page));
      if (params?.limit) searchParams.set('limit', String(params.limit));

      const queryString = searchParams.toString();
      const url = `/admin/audit-logs${queryString ? `?${queryString}` : ''}`;

      return apiFetch<PaginatedAuditLogs>(url);
    },
  });
}

/**
 * Fetch a single audit log entry by ID.
 */
export function useAuditLogDetail(id: string, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: queryKeys.admin.auditLogDetail(id),
    queryFn: async () => {
      return apiFetch<AuditLogEntry>(`/admin/audit-logs/${id}`);
    },
    enabled: options?.enabled ?? !!id,
  });
}
